import { render } from "./AdminRotaPage.vue?vue&type=template&id=7c867eb7&scoped=true"
import script from "./AdminRotaPage.vue?vue&type=script&lang=js"
export * from "./AdminRotaPage.vue?vue&type=script&lang=js"

import "./AdminRotaPage.vue?vue&type=style&index=0&id=7c867eb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c867eb7"]])

export default __exports__